import { AutoCast, Entity } from '@beecore/core';

@Entity()
export class SfeUserEntity {
  /** Chave do usuário */
  id: number;
  /** Nome de usuário usado para autenticação. */
  userName: string;
  /** Nome. */
  name: string;
  /** Sobrenome. */
  surname: string;
  /** Endereço de email do usuário. */
  emailAddress: string;
  /** Quando `true`, o usuário pode acessar a aplicação. */
  isActive: boolean;
  /** Nome completo do usuário. */
  fullName: string;
  /** Data en que o usuário foi criado. */
  @AutoCast(Date) lastLoginTime: Date;
  /** Data da última atualização de dados deste registro. */
  @AutoCast(Date) creationTime: Date;
}
